import React, { useEffect, useRef, useState } from "react";
import "../../../StyleSheet/MainComponent/Role/RoleCreate.scss";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getStateCreateActions,
  setStateetrieveAction,
  setStateEditActions,
  setTablePositionPersist
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
const StateCreateForm = (props) => {
  const State = useSelector((state) => state);
   const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)
  
  const { setShow, show, currentPage, EditId , search } = props;
 const inputRef =useRef();
  const initialState = {
    State: "",
    description: "",
    pre_area: "",
    prefix:null,
    sequence:null
  };
const [datas , setDatas] = useState(initialState);

  useEffect(() => {
    if (EditId != undefined && EditId != "") {
      const payload = {
        EditId: EditId,
      };
      dispatch(setStateetrieveAction(payload));
    }
  }, []);

  const [StateError, setStateError] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [preAreaErr, setPreareaErr] = useState("");
  const [ prefixerr , setprefixerr] = useState("");
  const [sequenceerr , setsequenceerr] = useState("")
  const handleClose = () => {
    setShow(false);
  };
  const HandleChanges = (e) => {
    if (e.target.name == "pre_area") {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.slice(0, 4),
        };
      });
    }
    else if (e.target.name == "description") {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.slice(0, 300),
        };
      });
    }
    else {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value,
        };
      });
    }
  };


 const HandleChanges_state = (e) => {
  const { name, value } = e.target;

  // Allow ONLY alphabets & spaces
  const cleaned = value.replace(/[^a-zA-Z ]/g, "");

  let limited = cleaned; // define once

  if (name === "State") {
    // State → allow 40 characters
    limited = cleaned.slice(0, 40);
  } else {
    // Other fields → allow 9 characters
    limited = cleaned.slice(0, 9);
  }

  setDatas((prev) => ({
    ...prev,
    [name]: limited,
  }));
};

  useEffect(() => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.StateRetrieve.StateRetrieve.id
    ) {
      setDatas({
        ...datas,
        State: State.StateRetrieve.StateRetrieve.state_name,
        pre_area: State.StateRetrieve.StateRetrieve.pre_area,
        description: State.StateRetrieve.StateRetrieve.description,
        prefix:State.StateRetrieve.StateRetrieve.prefix,
        sequence:State.StateRetrieve.StateRetrieve.sequence,
      });
    }
  }, [State.StateRetrieve.StateRetrieve]);
 const [forEdit , setforEdit] = useState(false)

  const dispatch = useDispatch();

  const HandleSubmit = () => {
    // console.log(datas);

    if (
      EditId == undefined ||
      EditId == "" ||
      !State.StateRetrieve.StateRetrieve.id
    ) {
      var a = 0;
      if (datas.State == "") {
        a = 1;
        setStateError("*State is Required");
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (datas.pre_area == "") {
        a = 1;
        setPreareaErr("*Pre area is Required");
      }
               if(!datas?.prefix || datas?.prefix == null){
      a = 1;
      setprefixerr("*Prefix is required")
     }
      if(!datas?.sequence || datas?.sequence == null){ 
      a = 1;
      setsequenceerr("*Sequence  is required")
     }
      if (a == 0) {
        // console.log(datas ,"inner");
        const payload = {
          datas: datas,
          currentPage: currentPage,
          search:search
        };
const newEntry = { updated: true };
        const result = {
          ...TablePositionPersist.Overall_stateDatas,
         page: 1, // Set page to 1
          ...newEntry
        };
                
        dispatch(
          setTablePositionPersist({
            data: result,
            pageName: "Overall_stateDatas",
          }))
        dispatch(getStateCreateActions(payload, props.setShow()));
      }
    }
  };
  const HandleSubmits = (e) => {
    e.preventDefault();
  };
  const HandleEdits = () => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.StateRetrieve.StateRetrieve.id
    ) {
      var a = 0;
      if (datas.State == "") {
        a = 1;
        setStateError("*State is Required");
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (datas.pre_area == "") {
        a = 1;
        setPreareaErr("*Pre area is Required");
      }
          if(!datas?.prefix || datas?.prefix == null){
      a = 1;
      setprefixerr("*Prefix is required")
     }
      if(!datas?.sequence || datas?.sequence == null){ 
      a = 1;
      setsequenceerr("*Sequence  is required")
     }
      if (a == 0) {
        const payload = {
          datas: datas,
          currentPage: currentPage,
          EditId: EditId,
          search:search
        };

        const newEntry = { updated: true };
                const result = {
                  ...TablePositionPersist.Overall_stateDatas,
                 page: 1, // Set page to 1
                  ...newEntry
                };
                        
                dispatch(
                  setTablePositionPersist({
                    data: result,
                    pageName: "Overall_stateDatas",
                  }))

        dispatch(setStateEditActions(payload, props.setShow()));
      }
    }
  };

  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
      event.preventDefault();
    }
  
    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData('text');
    
    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, '');
    
    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();
    
      event.target.value = filtered;
      HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
    
  };
 
  const preventwheel = (event) => {
    if (event.target&& event.target.className == "form-control"|| event.target.class =="form-control") {
    event.preventDefault();
    }
  }


 
  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {

      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (event.target&& event.target.className == "form-control"|| event.target.class =="form-control") {
        event.preventDefault();
      }
    };
    if (inputElement) {

      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);


  
  

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{width:"48%"}}>
            <div className="asds">
              <div class="ModalHeader">
                {EditId == undefined || EditId == "" ? (
                  <span className="UserCreate">State  </span>
                ) : (
                  <span> State  </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>

              <form class="row g-3 form-fields-wrapper" onClick={HandleSubmits} 
               style={{height:"50%", overflow:"auto",margin:"0",maxHeight:"500px",marginBottom:"12px !important", padding:"9px"}}>
                <div class="col-12 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    State Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={datas.State}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges_state(e);
                      setStateError("");
                    }}
                    required
                    name="State"
                    style={{
                      padding: "15px",
                      // borderRadius: "12px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{StateError}</p>
                </div>

                <div class="col-12 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Pre Area
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    value={datas.pre_area}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setPreareaErr("");
                    }}
                    onKeyDown={(evt) => {
                      preventZoom(evt)

                     }}
                     onPaste={(evt) => handlePaste(evt)} // Handle pasting
                     onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel

                     ref={inputRef}
          required
                    name="pre_area"
                    style={{
                      padding: "15px",
                      // borderRadius: "12px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{preAreaErr}</p>
                </div>

                  <div className="col-12 field-div">
    <label
      htmlFor="prefix"
class="form-label"
      style={{ fontSize: "15px" }}
    >
      Prefix <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="text"
      className="form-control"
      value={datas.prefix || ""}
      autoComplete="off"
      onChange={(e) => {
           const value = e.target.value;
        HandleChanges_state(e);
        setprefixerr("")
      }}
       onKeyDown={(e) => {
      // Prevent numbers (0–9)
      if (e.key >= "0" && e.key <= "9") {
        e.preventDefault();
      }
    }}
      required
      name="prefix"
      style={{ padding: "15px" }}
    />
                      <p style={{ color: "red", marginTop: "5px" }}>{prefixerr}</p>

  </div>

    <div className="col-12 field-div">
    <label
      htmlFor="sequence"
class="form-label"
      style={{ fontSize: "15px" }}
    >
      Sequence <span style={{ color: "red" }}>*</span>
    </label>
    <input
      type="number"
      className="form-control"
      value={datas.sequence || ""}
      autoComplete="off"
      onChange={(e) => {
            if (e.target.value.length > 8) return;   // ← prevent more than 8 digits

        HandleChanges(e);
        setsequenceerr("")
      }}
      onKeyDown={(evt) => preventZoom(evt)}
  onPaste={(e) => {
    const paste = e.clipboardData.getData("text");
    if (paste.length > 8) e.preventDefault(); // prevent >8 digits paste
  }}
      onWheel={(evt) => preventwheel(evt)}
      required
      name="sequence"
      style={{ padding: "15px" }}
    />
                          <p style={{ color: "red", marginTop: "5px" }}>{sequenceerr}</p>

  </div>





                <div class="col-12 field-div">
                  <label
                    for="validationCustom02"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Description
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    autoComplete="off"
                    value={datas.description}
                    onChange={(e) => {
                      HandleChanges(e);
                      setDescriptionError("");
                    }}
                    name="description"
                    required
                    style={{
                      padding: "15px",
                      // borderRadius: "12px",
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {DescriptionError}
                  </p>
                </div>
              </form>

              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "space-between",
                  alignItems: "center",
                   marginTop:"30px"
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
 
                    HandleEdits(e);
                  }}

                >
                  Submit
                </button>

                <button class="btn CancelBtn" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StateCreateForm;
